type Config = {
  [key: string]: {
    baseURL: string;
  };
};

const config: Config = {
  dev: {
    baseURL: "http://localhost:8080",
  },
  // Handle empty string environment
  "": {
    baseURL: "",
  }
};

export default config;